import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/barcode.css";
import Loader from "./Loader";
import { SidebarLayout } from "./SidebarLayout";
import DetailsContent from "./child/DetailsContent";
import Authentication from "./child/Modal/Authentication";
import { getBackToItemsPage, getDetailsContentProps, getAuthenticationObject } from "../js/helper";
import { getVipLoanStatus, postVipLoanCompletion } from "../js/api/vip";

export const VipDetailsPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const backToItemsPage = getBackToItemsPage(navigate);
  const detailsContentProps = getDetailsContentProps(state, backToItemsPage);

  // On Done: first confirm the VIP journey is still valid, then complete the loan.
  const handleDone = () => {
    setIsLoading(true);
    setErrorMessage("");

    getVipLoanStatus({
      vipCode: state?.RBPObject?.vipCode,
      merchantId: state?.selectedValue,
      isJourneyCheck: true,
    })
      .then((res) => {
        const envelope = res?.data || {};
        const journey = envelope.data || {};
        // Real journey status can be nested under `data` (error) or at the top level (success).
        const statusCode = journey.status ?? envelope.status;

        if (statusCode === "00") {
          completeLoan();
          return;
        }

        setIsLoading(false);
        const message = journey.message || envelope.message || envelope.errors?.[0]?.message
          || "This QR code is no longer valid. Please scan again.";
        setErrorMessage(message);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
        const message = err?.response?.data?.errors?.[0]?.message || err?.message || "Something went wrong. Please try again.";
        setErrorMessage(message);
      });
  };

  // Complete the VIP loan; navigate back to items only on a successful response.
  const completeLoan = () => {
    const details = state?.productDetails;
    details.applicationType = (() => {
      const { segmentInfo, ...rest } = details.applicationType;
      return rest;
    })();
    postVipLoanCompletion(details)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status?.code === "00") {
          backToItemsPage();
        } else {
          setErrorMessage(res?.data?.status?.message || "Something went wrong. Please try again.");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
        // Error (400): { errors: [{ errorCode, message }] }
        const message = err?.response?.data?.errors?.[0]?.message || err?.message || "Something went wrong. Please try again.";
        setErrorMessage(message);
      });
  };

  // Reuse the Authentication modal to surface completion errors (its "error" scenario).
  const authenticationObject = getAuthenticationObject({
    show: !!errorMessage,
    data: errorMessage
      ? { status: "error", message: errorMessage, data: { message: errorMessage } }
      : null,
    errorActionLabel: "Try again",
    onScanNew: () => {
      // "Try again" — dismiss the popup and re-run the completion flow.
      setErrorMessage("");
      handleDone();
    },
    onClose: () => setErrorMessage(""),
  });

  return (
    <div className="QR-Code-Page d-flex" style={{ backgroundColor: "rgb(250, 250, 252)" }}>
      {errorMessage && <Authentication {...authenticationObject} />}
      <SidebarLayout sideNavPosition={4}>
        {isLoading && <Loader />}
        <div className="page-title">Reverse QR</div>
        <div className="item-details">
          <div className="item-details-desc">
            <div className="QR_title">Submission details</div>
            <div className="sub-title py-2">
              I-review at kumpirmahin ang Loan Details
            </div>
          </div>
          <DetailsContent {...detailsContentProps} />
        </div>

        <div className="Next-btn d-flex w-100">
          <div className="next-page-btn  text-end w-100">
            <button className="btn btn-dark" onClick={handleDone} disabled={isLoading}>
              Done <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </SidebarLayout>
    </div>
  );
};

export default VipDetailsPage;
